<template>
  <div class="details-content">
    <div class="details-header">
      <div class="title">
        <div class="title-icon"></div>
        <h2>考试查看权限</h2>
      </div>
    </div>
    <div class="content">
      <span style="margin-right:20px;diplay:inline-block;" >角色选择</span>
      <el-select
        v-model="value"
        default-first-option
        multiple
        placeholder="请选择角色"
        @change="changeRole"
      >
        <el-option
          v-for="item in options"
          :key="item.id"
          :label="item.value"
          :value="item.id"
        ></el-option>
      </el-select>
      <p style="color:green;position:relative;left:72px;" v-if="value.length === 0 || value === ''" >空表示所有角色可以查看该次考试</p>
    </div>
    <div class="details-header">
      <div class="title">
        <div class="title-icon"></div>
        <h2>考试分析过滤</h2>
      </div>
    </div>
    <div class="content" style="margin-bottom: 50px;">
      <span style="margin-right:20px;diplay:inline-block;" >学生姓名</span>
      <el-select
          v-model="selectedStudentList"
          default-first-option
          multiple
          filterable
          placeholder="请选择学生"
          @remove-tag="handleStudentRemove"
          @keyup.native.enter="handleEnterKeyup"
      >
        <el-option
            v-for="item in studentList"
            :key="item.id"
            :label="item.name + ' ' + item.code"
            :value="item.id"
            @click.native="handleStudentClick(item.id)"
        ></el-option>
      </el-select>
    </div>
  </div>
</template>

<script>
export default {
  name: "detailJurisdiction",
  data() {
    return {
      value: "",
      studentList: [],
      selectedStudentList: [],
      prevSelectedStudentCount: 0,
      changedStudentId: '',
      options: []
    };
  },
  props: {
    examId: {
      type: String,
      default: ""
    }
  },
  watch: {
    selectedStudentList (val, oldVal) {
      this.prevSelectedStudentCount = oldVal.length

      if (val.length > oldVal.length) {
        this.changedStudentId = val[val.length - 1]
      } else if (val.length < oldVal.length) {
        const changedIds = oldVal.filter(id => !val.includes(id))
        this.changedStudentId = changedIds && changedIds.length ? changedIds[0] : ''
      }
    }
  },
  created() {
    this.getRoleList();
    this.getExamRole();
    this.getAllStudents()
    this.getExcludedStudents()
  },
  methods: {
    getExamRole () {
      this.$https.post("/api/score/examRoleList", {examId: this.$route.query.examId})
              .then(res => {return res.data;}).catch(error => {
                return error;
              }).then(data => {
                this.value = Array.from(data, item => item.id)
              });
    },
    getRoleList() {
      this.$https
        .get("/api/role/list")
        .then(res => {
          return res.data;
        })
        .catch(error => {
          return error;
        })
        .then(data => {
          data.forEach((item, key) => {
            this.options.push({
              value: item.name,
              key: key,
              id: item.id
            });
          });
        });
    },
    changeRole(values) {
      this.$https
        .post("/api/score/modifyExamRole", {
          examId: this.examId,
          roles: values
        })
        .then(res => {
          let examId = this.$route.query.examId
          let obj = {
            examId: this.$route.query.examId,
            value: this.value
          }
          this.$notify({
            title: "成功",
            message: "修改权限成功",
            type: "success"
          });
          return res;
        })
        .catch(error => {
          this.$notify({
            title: "警告",
            message: "发送数据失败",
            type: "warning"
          });
          return error;
        });
    },
    search(arr, result) {
      let i = arr.length;
      while ((i -= 1)) {
        if (arr[i].value === result) {
          return i;
        }
      }
      return null;
    },
    getAllStudents () {
      this.$https.get('/api/score/excludeStudent/search', {
        params: {
          examId: this.$route.query.examId,
          studentName: ''
        }
      }).then(response => {
        if (response.code === 0) {
          this.studentList = response.data || []
        }
      })
    },
    getExcludedStudents () {
      this.$https.get('/api/score/excludeStudent/get', {
        params: {
          examId: this.$route.query.examId
        }
      }).then(response => {
        if (response.code === 0) {
          const selectedStudentList = response.data || []
          this.selectedStudentList = selectedStudentList.map(item => item.id)
        }
      })
    },
    handleStudentClick (studentId) {
      if (this.prevSelectedStudentCount < this.selectedStudentList.length) {
        // add
        this.handleStudentAdd(studentId)
      } else if (this.prevSelectedStudentCount > this.selectedStudentList.length) {
        // delete
        this.handleStudentRemove(studentId)
      }
    },
    handleStudentRemove (studentId) {
      this.$https.post('/api/score/excludeStudent/delete', {
        examId: this.$route.query.examId,
        studentId
      }).catch(error => {
        console.dir(error)
      })
    },
    handleStudentAdd (studentId) {
      this.$https.post('/api/score/excludeStudent/add', {
        examId: this.$route.query.examId,
        studentId
      }).catch(error => {
        console.dir(error)
      })
    },
    handleEnterKeyup () {
      this.handleStudentClick(this.changedStudentId)
    }
  }
};
</script>

<style lang="scss" scoped>
.details-content {
  margin-top: 30px;
  background: #fff;
}
.details-header {
  height: 37px;
  padding: 30px 20px 36px 19px;
  .title {
    float: left;
    line-height: 37px;
    .title-icon {
      display: inline-block;
      margin-right: 5px;
      width: 4px;
      height: 17px;
      background: #2996f3;
    }
    h2 {
      display: inline-block;
      font-size: 22px;
      margin: 0;
    }
  }
  .details-button {
    line-height: 37px;
    float: right;
  }
  .open {
    float: right;
    span {
      margin-right: 13px;
      font-size: 16px;
      font-weight: 600;
      color: rgba(51, 51, 51, 1);
      position: relative;
      top: 3px;
    }
  }
}
.content {
  padding: 0 20px 45px 19px;
  text-align: left;
}
// 搜索框重置样式
.content /deep/ .el-select {
  .el-tag--light {
    background: #e6f4ff;
    color: #2196f3;
    .el-icon-close {
      color: #2196f3;
      background: #a9d9ff;
    }
  }
}
</style>
